import React from 'react';
import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import GuideMessage from '../message/GuideMessage';
import { CustomButton } from '../button';

// 가입 완료 — 개인회원은 바로 로그인, 기업회원은 '가입신청 접수가 완료되었습니다. 곧 연락드리겠습니다.'(승인 뒤 로그인)
function Success() {
  const classes = useStyles();
  const history = useHistory();
  const { state } = useLocation();
  const applied = Boolean(state && state.applied);

  return (
    <React.Fragment>
      <Grid container direction="row" justify="center" wrap="nowrap" className={classes.signUpSuccess}>
        <Grid item className={classes.signUpForm}>
          <Grid container direction="column" justify="center" className={clsx('narrowFormArea', classes.textField)}>
            <Grid item>
              <Grid container direction="column" justify="center" alignItems="center">
                {applied ? (
                  <GuideMessage
                    title="가입신청 접수가 완료되었습니다."
                    resultTitle="가입신청 접수가 완료되었습니다."
                    subTitle="곧 연락드리겠습니다."
                  />
                ) : (
                  <GuideMessage
                    title="환영합니다."
                    resultTitle="환영합니다."
                    subTitle="맡겨만 주세요. 안전하게 배송하겠습니다."
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <CustomButton
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => { history.push(applied ? '/' : '/login'); }}
          >
            {applied ? '확인' : '로그인 하기'}
          </CustomButton>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  signUpSuccess: {
    paddingTop: 200,
    paddingBottom: 150,
    [theme.breakpoints.down('sm')]: { paddingTop: 80 },
  },
  signUpForm: {
    width: 420,
    marginLeft: 20,
    marginRight: 20,
  },
  textField: {
    paddingBottom: 80,
  },
}));

export default Success;
